import {
	ExtendedDashboardProps,
	LoadExistingFusionDashboardParams,
	BuildDashboardContext,
} from './types';
import { getAvailableFusionDashboards } from '@/services/dashboards/fusion-dashboards-service';
import { loadExistingDashboardFromFusion } from '@/services/dashboards/fusion-dashboards-service';
import { getBaseDashboardConfig } from '@/services/dashboards/dashboards-service';
import { nanoidHex } from '@/utils/id-utils';
import { devDebug } from '@/utils/dev-debug';

export const loadExistingFusionDashboard = async (
	{ dashboardTitle }: LoadExistingFusionDashboardParams,
	context: BuildDashboardContext,
) => {
	const { saveDashboard, httpClient } = context;
	devDebug('toolCall', {
		tool: 'loadExistingFusionDashboard',
		dashboardTitle,
	});

	const availableDashboards = await getAvailableFusionDashboards(httpClient);

	const fusionDashboard = availableDashboards.find(
		(dashboard) => dashboard.dashboardTitle === dashboardTitle,
	);

	if (!fusionDashboard) {
		throw new Error(
			`Fusion dashboard with title ${dashboardTitle} not found`,
		);
	}

	const dashboardProps: ExtendedDashboardProps =
		await loadExistingDashboardFromFusion(
			fusionDashboard.dashboardId,
			httpClient,
		);

	const updatedDashboardProps: ExtendedDashboardProps = {
		...dashboardProps,
		// Use the base dashboard config to ensure the dashboard is created with the correct default settings
		config: {
			...dashboardProps.config,
			...getBaseDashboardConfig(),
		},
		// Generate a new artifact id for the dashboard
		artifactId: dashboardProps.artifactId || nanoidHex(),
	};

	saveDashboard?.(updatedDashboardProps);

	return {
		message: 'Dashboard loaded successfully from Fusion.',
	};
};
